import React from 'react';
import { Droplets, Sprout, Flame, Siren, Home, Bath, Utensils, Hammer } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { mockServices } from '../data/mock';

const iconMap = {
  droplets: Droplets,
  sprout: Sprout,
  flame: Flame,
  siren: Siren,
  home: Home,
  bath: Bath,
  utensils: Utensils,
  hammer: Hammer
};

export const Services = () => {
  return (
    <section id="servizi" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            I Nostri Servizi
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Soluzioni complete per ogni tua esigenza di idraulica e ristrutturazione
          </p>
        </div>

        {/* Services Tabs */}
        <Tabs defaultValue="idraulica" className="w-full">
          <TabsList className="grid w-full max-w-md mx-auto grid-cols-2 mb-12">
            <TabsTrigger value="idraulica" className="text-lg">Idraulica</TabsTrigger>
            <TabsTrigger value="edilizia" className="text-lg">Edilizia</TabsTrigger>
          </TabsList>

          <TabsContent value="idraulica">
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {mockServices.idraulica.map((service) => {
                const Icon = iconMap[service.icon];
                return (
                  <Card 
                    key={service.id} 
                    className="group hover:shadow-xl transition-all duration-300 border-2 hover:border-blue-200"
                  >
                    <CardHeader>
                      <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-blue-600 transition-colors">
                        <Icon className="w-7 h-7 text-blue-600 group-hover:text-white transition-colors" />
                      </div>
                      <CardTitle className="text-xl">{service.title}</CardTitle>
                    </CardHeader>
                    <CardContent>
                      <CardDescription className="text-base">
                        {service.description}
                      </CardDescription>
                    </CardContent>
                  </Card>
                );
              })}
            </div>
          </TabsContent>

          <TabsContent value="edilizia">
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {mockServices.edilizia.map((service) => {
                const Icon = iconMap[service.icon];
                return (
                  <Card 
                    key={service.id} 
                    className="group hover:shadow-xl transition-all duration-300 border-2 hover:border-orange-200"
                  >
                    <CardHeader>
                      <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-orange-500 transition-colors">
                        <Icon className="w-7 h-7 text-orange-600 group-hover:text-white transition-colors" />
                      </div>
                      <CardTitle className="text-xl">{service.title}</CardTitle>
                    </CardHeader>
                    <CardContent>
                      <CardDescription className="text-base">
                        {service.description}
                      </CardDescription>
                    </CardContent>
                  </Card>
                );
              })}
            </div>
          </TabsContent>
        </Tabs>

        {/* Emergency Service Banner */}
        <div className="mt-16 bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl p-8 sm:p-12 text-white">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-4">
              <div className="bg-white/20 rounded-full p-4">
                <Siren className="w-8 h-8" />
              </div>
              <div>
                <h3 className="text-2xl sm:text-3xl font-bold mb-2">Pronto Intervento 24/7</h3>
                <p className="text-blue-100">Emergenze idrauliche? Siamo sempre disponibili</p>
              </div>
            </div>
            <a href="tel:3514826210" className="bg-white text-blue-600 px-8 py-4 rounded-lg font-bold text-lg hover:bg-blue-50 transition-colors whitespace-nowrap">
              Chiama: 351 482 6210
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
